import Menu from './tm3-menu';
import { MenuItem } from '@material-ui/core';

export default Menu;

export { Menu, MenuItem };
